import { useEffect, useState } from "react";
import { Image } from "../../../Image/Image";
import { FicheType } from "../../FicheType/FicheType";
import { MoreInfo } from "../../MoreInfo/MoreInfo";
import './FicheInspiratie.scss';
export const FicheInspiratie = (props) => {
    const [bodyItems, setBodyItems] = useState(null);
    //Processs body items
    useEffect(() => {
        let items = props.processFicheItems(props.data.body.items);
        setBodyItems(items);
    }, [JSON.stringify(props.data.body.items)]);

    return (
        <div
            className={`c-fiche c-inspiration-full ${props.data?.hasDetail ? "u-has-detail" : ""}`}
            onClick={() => {
                if (props.data?.hasDetail && props.openPopup) {
                    props.openPopup(props.data.urlSegment);
                }
            }}
            data-aos="fade-up"
        >
            <div>
                <FicheType type={props.data.type} style={{ backgroundColor: (props.data.typeColor != null ? "#" + props.data.typeColor : "unset") }} />
                <div className="image" title="Meer over">
                    {props.data?.image?.url &&
                        <Image alt={props.data.title} src={(props.data.image && props.data.image.url)} />
                    }
                </div>
                <header className="c-fiche__header">
                    {(props.data?.tagIcon?.url &&
                        <div className="c-tag-list">
                            <div className="c-tag corona" title="coronaproof">
                                <Image alt={props.data.tagIcon.alt} src={props.data.tagIcon.url} />
                            </div>
                        </div>)}
                    <h2 className="title" title={props.title}>
                        {props.data.title}
                    </h2>
                    {props.data.text}
                </header>
                <div className="c-fiche__body">
                    <ul>
                        {bodyItems}
                    </ul>
                </div>
                <MoreInfo
                    data={props.data}
                    openPopup={props.openPopup}
                    cta={props.dictionary.moreInfo}
                />
            </div>
        </div>
    );
}